import { FC } from "react";
import { Box, Typography } from "@mui/material";

import Props from "./helper.interface";
import { SubTitle, Paragraph } from "./helper.styled";

const Helper: FC<Props> = ({ iconSrc, text, title }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 5px",
        gap: "1rem",
      }}
    >
      <img src={iconSrc} alt="" />
      <SubTitle>{title}</SubTitle>
      <Paragraph>{text}</Paragraph>
    </Box>
  );
};

export default Helper;
